import React from 'react';
import { useState } from 'react';
import { AlertCircle } from 'lucide-react';

const VideoSection: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 text-[#2574B5]">
              Warum Sie den EU AI Act Kompetenznachweis brauchen?
            </h2>
            <p className="text-xl text-gray-600">
              Ab 2026 müssen Unternehmen den Kompetenz­nachweis ihrer KI-Nutzer vorlegen.
              Erfahren Sie in unserem kurzen Video, wie der EU AI Act Ihr Unternehmen betrifft und wie Sie sich optimal vorbereiten können.
            </p>
          </div>
          
          <div className="relative bg-white rounded-xl shadow-xl overflow-hidden">
            {loading && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            )}
            
            {error && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                <div className="text-center p-8">
                  <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
                  <p className="text-gray-600">
                    Das Video konnte nicht geladen werden. Bitte versuchen Sie es später erneut.
                  </p>
                </div>
              </div>
            )}
            
            <iframe
              className="w-full h-[500px]"
              src="https://player.vimeo.com/video/1090767086?title=0&byline=0&portrait=0&badge=0"
              title="Warum Sie den EU AI Act Kompetenznachweis brauchen"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              onLoad={() => setLoading(false)}
              onError={() => {
                setLoading(false);
                setError(true);
              }}
              style={{ border: 'none' }}
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;